// src/services/localTime.js
//
// Clock helpers for deciding whether a status is in force. Badge times are
// converted to the office's local zone by the backend; nothing here converts
// stored timestamps.

/** The current time as "HH:MM" in a named zone, or the viewer's own if none. */
export function nowHHMM(timeZone) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    ...(timeZone ? { timeZone } : {})
  }).formatToParts(new Date())

  const h = parts.find((p) => p.type === 'hour')?.value ?? '00'
  const m = parts.find((p) => p.type === 'minute')?.value ?? '00'

  // en-GB with hour12:false can render midnight as "24"; the comparisons
  // elsewhere expect "00".
  return `${h === '24' ? '00' : h}:${m}`
}

/**
 * Is a status in force at this moment?
 *
 * A status with no times covers its whole day. One with a start time has not
 * begun before it, and one with an end time is over after it. Somebody who
 * schedules working from home for the afternoon is not at home this morning,
 * and the board used to say they were the moment the entry was saved.
 */
export function statusActiveNow(status, timeZone) {
  if (!status) return false
  if (!status.start_time) return true

  const now = nowHHMM(timeZone)
  if (now < status.start_time) return false
  if (status.end_time && now > status.end_time) return false

  return true
}
